/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CreatePopupCampaignCommand } from '../models/CreatePopupCampaignCommand';
import type { PopupCampaignAdminViewModel } from '../models/PopupCampaignAdminViewModel';
import type { PopupCampaignAudienceEstimateViewModel } from '../models/PopupCampaignAudienceEstimateViewModel';
import type { PopupCampaignPostalCodeViewModel } from '../models/PopupCampaignPostalCodeViewModel';
import type { PopupCampaignPreviewTokenViewModel } from '../models/PopupCampaignPreviewTokenViewModel';
import type { PopupCampaignResolvedLocationViewModel } from '../models/PopupCampaignResolvedLocationViewModel';
import type { PopupCampaignStatsViewModel } from '../models/PopupCampaignStatsViewModel';
import type { ReorderPopupCampaignsCommand } from '../models/ReorderPopupCampaignsCommand';
import type { ResolvePopupCampaignLocationCommand } from '../models/ResolvePopupCampaignLocationCommand';
import type { UpdatePopupCampaignCommand } from '../models/UpdatePopupCampaignCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PopupCampaignsAdminService {
    /**
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static getApiPopupCampaignsAdmin(): CancelablePromise<Array<PopupCampaignAdminViewModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/popup-campaigns-admin',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdmin(
        requestBody?: CreatePopupCampaignCommand,
    ): CancelablePromise<PopupCampaignAdminViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static getApiPopupCampaignsAdmin1(
        id: string,
    ): CancelablePromise<PopupCampaignAdminViewModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/popup-campaigns-admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static putApiPopupCampaignsAdmin(
        id: string,
        requestBody?: UpdatePopupCampaignCommand,
    ): CancelablePromise<PopupCampaignAdminViewModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/popup-campaigns-admin/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static deleteApiPopupCampaignsAdmin(
        id: string,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/popup-campaigns-admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static putApiPopupCampaignsAdminReorder(
        requestBody?: ReorderPopupCampaignsCommand,
    ): CancelablePromise<Array<PopupCampaignAdminViewModel>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/popup-campaigns-admin/reorder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdminPublish(
        id: string,
    ): CancelablePromise<PopupCampaignAdminViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin/{id}/publish',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignAdminViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdminUnpublish(
        id: string,
    ): CancelablePromise<PopupCampaignAdminViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin/{id}/unpublish',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignStatsViewModel Success
     * @throws ApiError
     */
    public static getApiPopupCampaignsAdminStats(
        id: string,
    ): CancelablePromise<PopupCampaignStatsViewModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/popup-campaigns-admin/{id}/stats',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignAudienceEstimateViewModel Success
     * @throws ApiError
     */
    public static getApiPopupCampaignsAdminAudienceEstimate(
        id: string,
    ): CancelablePromise<PopupCampaignAudienceEstimateViewModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/popup-campaigns-admin/{id}/audience-estimate',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignAudienceEstimateViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdminEstimateRecalculate(
        id: string,
    ): CancelablePromise<PopupCampaignAudienceEstimateViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin/{id}/estimate/recalculate',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PopupCampaignResolvedLocationViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdminTargetingResolveLocation(
        requestBody?: ResolvePopupCampaignLocationCommand,
    ): CancelablePromise<PopupCampaignResolvedLocationViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin/targeting/resolve-location',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns PopupCampaignPostalCodeViewModel Success
     * @throws ApiError
     */
    public static getApiPopupCampaignsAdminPostalCodes(): CancelablePromise<Array<PopupCampaignPostalCodeViewModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/popup-campaigns-admin/postal-codes',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PopupCampaignPreviewTokenViewModel Success
     * @throws ApiError
     */
    public static postApiPopupCampaignsAdminPreviewToken(
        id: string,
    ): CancelablePromise<PopupCampaignPreviewTokenViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/popup-campaigns-admin/{id}/preview-token',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param identityId
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static deleteApiPopupCampaignsAdminInteractions(
        id: string,
        identityId: string,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/popup-campaigns-admin/{id}/interactions/{identityId}',
            path: {
                'id': id,
                'identityId': identityId,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
